module.exports = "/dist/maruf2.jpg";